function showMoreEs() {
  let showMore = document.querySelectorAll('.open-list')

  showMore.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault()

      let parent = e.target.parentElement.parentElement
      let text = parent.querySelectorAll('.list-of-clients__item-hidden')
      text.forEach((el) => {
        el.classList.toggle('opened')
      })
      if (e.target.classList.contains('closed')) {
        e.target.classList.toggle('closed')
        e.target.innerHTML = 'Mostrar Menos'
      } else {
        e.target.classList.toggle('closed')
        e.target.innerHTML = 'Mostrar Más'
      }
    })
  })
}
showMoreEs()
